<script>
import DishCard from './dishCard.vue'
import { apiService } from '@/helpers/api.service';

export default {
    components: { DishCard },
    props: {
        dish: {
            type: Object,
            default: null,
        }
    },
    data() {
        return {
        };
    },
    mounted() {
    },
    methods: {
        publish(){
                const formData = new FormData();

                const attributes = ['file', 'name', 'description', 'unitPrice', 'isActive', 'isCeliac']

                for (const [key, value] of Object.entries(this.dish)){
                    if(attributes.find(e => e === key)){
                        formData.append(`${key}`, value)
                    }
                    if(key === 'type'){
                        const type = value
                        type.forEach(e => {
                            formData.append(`type[]`, e);
                        })
                    }
                    if(key === 'discount'){
                        const discount = value
                        Object.keys(discount).forEach(key => {
                            formData.append(`discount[${key}]`, discount[key]);
                        });
                    }
                    if(key === 'categories'){
                        const categories = value
                        if(categories){
                            categories.forEach((category, index) => {
                                formData.append(`categories[${index}][name]`, category.name);
                                formData.append(`categories[${index}][_id]`, category._id);
                            });
                        }
                    }
                    if(key === 'addon'){
                        const addon = value
                        formData.append('addon[0][name]', 'EXTRA');
                        const options = addon[0].options
                        options.forEach((option, index) => {
                            const optionName = `addon[0][options][${index}]`;
                            formData.append(`${optionName}[name]`, option.name);
                            formData.append(`${optionName}[price]`, option.price);
                        });
                    }
                    if(key === 'personalize'){
                        const personalize = value
                        const processObject = (personlizeObj, prefix = '') => {
                            for (const personalizeKey in personlizeObj) {
                                const hasPersonalizeProperty = Object.prototype.hasOwnProperty.call(personlizeObj, personalizeKey);
                                if (hasPersonalizeProperty) {
                                const personalizeValue = personlizeObj[personalizeKey];
                                const newPersonalizeKey = prefix ? `${prefix}[${personalizeKey}]` : personalizeKey;

                                if (Array.isArray(personalizeValue)) {
                                    processArray(personalizeValue, newPersonalizeKey);
                                } else if (typeof personalizeValue === 'object') {
                                    processObject(personalizeValue, newPersonalizeKey);
                                } else {
                                    formData.append(newPersonalizeKey, personalizeValue);
                                }
                                }
                            }
                            };
                            const processArray = (personalizeArr, prefix = '') => {
                            personalizeArr.forEach((personalizeItem, personalizeIndex) => {
                                const newPrefix = `${prefix}[${personalizeIndex}]`;

                                if (Array.isArray(personalizeItem)) {
                                processArray(personalizeItem, newPrefix);
                                } else if (typeof personalizeItem === 'object') {
                                processObject(personalizeItem, newPrefix);
                                } else {
                                formData.append(newPrefix, personalizeItem);
                                }
                            });
                            };
                            processArray(personalize, 'personalize');
                    }
                }

                if(this.dish.dishId) {

                    apiService.putDishById(this.dish.dishId, formData)
                    .then(() => {
                            apiService.getStoreById()
                            this.$bvModal.hide('dishPreview')
                            this.$emit('dish-toast', true)
                        })
                    .catch(()=> {
                        this.$bvModal.hide('dishPreview')
                        this.$emit('dish-toast', false)
                    })
                } else {

                    apiService.postDishByNewDish(formData)
                    .then(() => {
                            apiService.getStoreById()
                            this.$bvModal.hide('dishPreview')
                            this.$emit('dish-toast', true)
                        })
                    .catch(()=> {
                        this.$bvModal.hide('dishPreview')
                        this.$emit('dish-toast', false)
                    })
                }
        }
    },
}
</script>

<template>
    <b-modal id="dishPreview" centered size="lg" hide-footer="true">
        <div class="dish-preview">
            <h2>Vista previa</h2>
            <DishCard :dish="dish" class="dish-preview-card"/>
        </div>
        <div class="btn-dish-preview-container">
            <b-button href="#" type="submit" variant="success" class="btn-dish-preview btn-cancel" @click="$bvModal.hide('dishPreview')">
                Editar
            </b-button>
            <b-button href="#" type="submit" variant="success" class="btn-dish-preview" @click="publish()">
                Publicar plato
            </b-button>
        </div>
    </b-modal>
</template>

<style lang="scss" scoped>
@import "@/design/settings";
@import '@/design/views/my-dishes/dishPreview';
</style>
